// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"6cdfce34","850":"76c3ed7c"}[chunkId] + ".chunk.js";
};